<template>
  <div class="m-save-olap-report">
    <b-modal
      id="save-olap-report-modal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @close="localActive = false"
    >
      <svg
        class="m-save-olap-report-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-save-olap-report-title">Сохранить отчёт</div>
      <c-switcher
        v-model="switcherLocal"
        class="m-save-olap-report-switcher"
        type="group"
        :items="[
          { label: 'Обновить текущий', value: 'update_current' },
          { label: 'Сохранить как новый', value: 'save_as_new' },
        ]"
      />
      <c-input-old v-model="name" class="m-save-olap-report-input" :clearable="true" floating-label="Название отчёта" />
      <div class="m-save-olap-report-buttons">
        <c-button class="m-save-olap-report-buttons-cancel" label="Отменить" @click="localActive = false" />
        <c-button class="m-save-olap-report-buttons-apply" label="Сохранить" color="primary" @click="save()" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import Switcher from "@/components/controls2/Switcher";
import InputOld from "@/components/controls/input-old";

export default {
  name: "save-olap-report-modal",
  components: {
    "c-button": Button,
    "c-switcher": Switcher,
    "c-input-old": InputOld,
  },
  props: ["active", "countBonusesCurrent", "nameReport"],
  // props: ["active", "countBonusesCurrent"],
  data() {
    return {
      name: "",
      oldNameReport: "",
      localActive: false,
      switcherLocal: "update_current",
    };
  },

  watch: {
    switcherLocal(value) {
      if (value === "save_as_new") {
        this.name = "";
      } else {
        this.name = this.nameReport;
      }
    },
    localActive(value) {
      if (!value) {
        this.$emit("close");
      }
    },
    active(value) {
      if (value) {
        this.name = this.nameReport;
        this.oldNameReport = this.nameReport;
      }
      this.localActive = value;
    },
  },

  methods: {
    closeModal() {
      this.localActive = false;
    },
    save() {
      this.$emit("save", { name: this.name, type: this.switcherLocal });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-save-olap-report {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-family: Fira Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
  }

  &-switcher {
    margin-top: 30px;
  }

  &-input {
    margin-top: 20px;
  }

  &-buttons {
    margin-top: 30px;
    margin-bottom: 19px;
    display: flex;
    justify-content: flex-end;

    &-cancel {
      max-width: 120px;
    }

    &-apply {
      max-width: 125px;
      margin-left: 10px;
    }
  }
}
</style>
